export { default } from './EditTextBlock';

export const displayName = 'Text Block';
